<!-- ヘッダー -->
<div class="header p-d-flex">
  <!-- 左 -->
  <div class="left" [class.not-logedin]="!loginStatus">
    <!-- ロゴ1 -->
    <div class="logo1" (click)="moveHome()">
      <!-- ロゴ1画像 -->
      <img
        src="../../../../assets/images/logo1.png"
        width="120px"
        height="60px"
        alt="地方創生SDGs官民連携プラットフォーム"
      />
    </div>

    <!-- ロゴ2 -->
    <div class="logo2" (click)="moveHome()">
      <!-- ロゴ2画像 -->
      <img
        src="../../../../assets/images/logo2.png"
        width="50px"
        height="50px"
        alt=""
      />
    </div>
  </div>

  <!-- 右 -->
  <div class="right">
    <!-- 文字サイズ -->
    <div class="p-d-flex p-as-center textSize">
      <!-- 文字サイズテキスト -->
      <div class="p-as-center characterText">
        <label>文字のサイズ</label>
      </div>
      <!-- 文字サイズボタン -->
      <div class="characterTextButton">
        <p-selectButton
          [options]="textSizeList"
          [(ngModel)]="textSize"
          (onChange)="textChange()"
          optionLabel="name"
          optionValue="code"
        ></p-selectButton>
      </div>
    </div>
    <div class="not-login" *ngIf="!loginStatus">
      <!-- <label class="text">官民連携SDGsマッチングシステム</label> -->
      <!-- ボタンエリア -->
      <div class="p-d-flex p-ai-center">
        <button
          pButton
          type="button"
          label="会員登録"
          class="p-button-raised member-registr-button"
          (click)="moveA201()"
        ></button>
        <button
          pButton
          type="button"
          label="ログイン"
          class="p-button-raised login-button"
          (click)="moveB301()"
        ></button>
        <div class="tooltip-text p-buttons" (click)="moveA210()">
          既存会員は<br /><span class="tooltip-text-underline">こちら</span>から<br />ID設定
        </div>
      </div>
    </div>
  
    <!-- ロゴ3 -->
    <!-- <div class="p-as-center logo3"> -->
      <!-- ロゴ3画像 -->
      <!-- <a href="https://www.cao.go.jp/index.html" target="_blank">
        <img
          src="../../../../assets/images/logo_naikakufu.png"
          width="100px"
          height="30px"
          alt="内閣府"
        />
      </a>
    </div> -->
  </div>
</div>
